import classNames from 'classnames';
import React, { Component } from 'react';
import ReportLink from 'containers/ReportLinkContainer';
import SpinnerRect from 'components/SpinnerRect';
import { inProgress, isComplete } from 'support/reportStatusHelpers';
import PropTypes from 'prop-types';

/**
 * Extract a formatted address from an object with an appropriately structured address
 * @param {{address: {street: string, city: string, state: string}}} obj
 * @return {string}
 */
// Todo: Replace this function with a reselect selector when client-side data model, use of redux,
// and api calls are cleaned up
const address = (obj) => {
  const { street, city, state } = obj.address;
  return [street, city, state].some(value => value === undefined)
    ? ''
    : `${street}, ${city} ${state}`
  ;
};

class ReportRow extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };

    this.handleLoadingEvent.bind(this);
  }

  handleLoadingEvent(isLoading) {
    this.setState({
      loading: isLoading,
    });
  }

  render() {
    const { loading } = this.state;
    const { report } = this.props;
    const { createdAt, id, name, status, url, user } = report;
    const { firstName, lastName } = user;

    let download;
    const complete = isComplete(status);

    if (complete) {
      download = (
        <button
          className="download-button"
          type="submit"
        />
      );
    } else if (loading || inProgress(status)) {
      download = <SpinnerRect />;
    } else {
      download = <span className="text-danger">Error</span>;
    }

    return (
      <div key={report.id} className={classNames('row', 'report-row', complete ? '' : 'disabled')}>
        <ReportLink
          disabled={!complete}
          url={url}
          id={id}
          name={name}
          loadingEventHandler={isLoading => this.handleLoadingEvent(isLoading)}
        >
          <div className="col-md-1">{download}</div>
          <div className="col-md-3">{name}</div>
          <div className="col-md-4">{address(report)}</div>
          <div className="col-md-2">{firstName} {lastName}</div>
          <div className="col-md-2">{new Date(createdAt).toLocaleDateString('en-US')}</div>
        </ReportLink>
      </div>
    );
  }
}

ReportRow.propTypes = {
  report: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string.isRequired,
    address: PropTypes.shape({
      street: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
    }),
    createdAt: PropTypes.string,
    url: PropTypes.string,
    user_id: PropTypes.number,
    createdBy: PropTypes.string,
  }).isRequired,
};

export default ReportRow;
